// source: authentication.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.com.google.scout.chorus.proto.CallContext', null, global);
goog.exportSymbol('proto.com.google.scout.chorus.proto.CallContext.CallSource', null, global);
goog.exportSymbol('proto.com.google.scout.chorus.proto.CallContext.CallerRole', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.google.scout.chorus.proto.CallContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.google.scout.chorus.proto.CallContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.google.scout.chorus.proto.CallContext.displayName = 'proto.com.google.scout.chorus.proto.CallContext';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.toObject = function(opt_includeInstance) {
  return proto.com.google.scout.chorus.proto.CallContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.google.scout.chorus.proto.CallContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.google.scout.chorus.proto.CallContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    callerRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    callSource: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.google.scout.chorus.proto.CallContext}
 */
proto.com.google.scout.chorus.proto.CallContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.google.scout.chorus.proto.CallContext;
  return proto.com.google.scout.chorus.proto.CallContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.google.scout.chorus.proto.CallContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.google.scout.chorus.proto.CallContext}
 */
proto.com.google.scout.chorus.proto.CallContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {!proto.com.google.scout.chorus.proto.CallContext.CallerRole} */ (reader.readEnum());
      msg.setCallerRole(value);
      break;
    case 4:
      var value = /** @type {!proto.com.google.scout.chorus.proto.CallContext.CallSource} */ (reader.readEnum());
      msg.setCallSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.google.scout.chorus.proto.CallContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.google.scout.chorus.proto.CallContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.google.scout.chorus.proto.CallContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCallerRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCallSource();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.com.google.scout.chorus.proto.CallContext.CallerRole = {
  UNKNOWN_CALLER_ROLE: 0,
  USER: 1,
  MANAGER: 2,
  ADMIN: 3,
  OPERATOR: 4
};

/**
 * @enum {number}
 */
proto.com.google.scout.chorus.proto.CallContext.CallSource = {
  UNKNOWN_CALL_SOURCE: 0,
  SCOUT_DASHBOARD: 1,
  EXTERNAL_API: 2,
  LOCAL_TESTING: 3,
  INTERNAL_JOB: 4
};

/**
 * optional string org_id = 1;
 * @return {string}
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.getOrgId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.google.scout.chorus.proto.CallContext} returns this
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.setOrgId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.google.scout.chorus.proto.CallContext} returns this
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CallerRole caller_role = 3;
 * @return {!proto.com.google.scout.chorus.proto.CallContext.CallerRole}
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.getCallerRole = function() {
  return /** @type {!proto.com.google.scout.chorus.proto.CallContext.CallerRole} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.com.google.scout.chorus.proto.CallContext.CallerRole} value
 * @return {!proto.com.google.scout.chorus.proto.CallContext} returns this
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.setCallerRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional CallSource call_source = 4;
 * @return {!proto.com.google.scout.chorus.proto.CallContext.CallSource}
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.getCallSource = function() {
  return /** @type {!proto.com.google.scout.chorus.proto.CallContext.CallSource} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.com.google.scout.chorus.proto.CallContext.CallSource} value
 * @return {!proto.com.google.scout.chorus.proto.CallContext} returns this
 */
proto.com.google.scout.chorus.proto.CallContext.prototype.setCallSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


goog.object.extend(exports, proto.com.google.scout.chorus.proto);
